import WorkIm from "../assets/projects/workImg.jpeg";
import RealEst from "../assets/projects/realestate.jpg";

export const data = [
  {
    id: 1,
    name: "Outing",
    image: "https://ibbiza.s3.us-east-2.amazonaws.com/outing.png",
    github: "https://github.com/jkabore/outing",
    live: "https://outing.onrender.com",
  },
  {
    id: 2,
    name: "Ibiza",
    image: "https://ibbiza.s3.us-east-2.amazonaws.com/ibiza.png",
    github: "https://github.com/jkabore/ibiza",
    live: "https://ibiza.onrender.com",
  },
  {
    id: 3,
    name: "Produce POS",
    image: "https://ibbiza.s3.us-east-2.amazonaws.com/vitejob.png",
    github: "https://github.com/jkabore/produce-pos",
    live: "https://produce-pos.onrender.com",
  },
  {
    id: 4,
    name: "Vite Job",
    image: "https://ibbiza.s3.us-east-2.amazonaws.com/vite.png",
    github: "https://github.com/jkabore/ijobclient",
    live: "https://ijobclient.onrender.com",
  },
  {
    id: 5,
    name: "Fleemarket",
    image: "https://ibbiza.s3.us-east-2.amazonaws.com/fleemarket.png",
    github: "https://github.com/jkabore/fleemarket-client",
    live: "https://fleemarket.onrender.com",
  },
];
